
export const libraries = [
    {
        index: 0,
        brand: 'Miyuki',
        diameter: 3,
        width: 2.35,
        size: 8,
        shape: 'round',
        name: 'Miyuki Round 8/0',
        displayName: 'Miyuki Round 8/0'
    },
    {
        index: 1,
        brand: 'Miyuki',
        diameter: 2.12,
        width: 1.45,
        size: 11,
        shape: 'round',
        name: 'Miyuki Round 11/0',
        displayName: 'Miyuki Round 11/0'
    },
    {
        index: 2,
        brand: 'Miyuki',
        diameter: 1.5,
        width: 1.175,
        size: 15,
        shape: 'round',
        name: 'Miyuki Round 15/0',
        displayName: 'Miyuki Round 15/0'
    },
    {
        index: 3,
        brand: 'Miyuki',
        diameter: 3,
        width: 2.3,
        size: 8,
        shape: 'cylinder',
        name: 'Miyuki Delica 8/0',
        displayName: 'Miyuki Delica 8/0'
    },
    {
        index: 4,
        brand: 'Miyuki',
        diameter: 2.2,
        width: 1.69,
        size: 10,
        shape: 'cylinder',
        name: 'Miyuki Delica 10/0',
        displayName: 'Miyuki Delica 10/0'
    },
    {
        index: 5,
        brand: 'Miyuki',
        diameter: 1.7,
        width: 1.3,
        size: 11,
        shape: 'cylinder',
        name: 'Miyuki Delica 11/0',
        displayName: 'Miyuki Delica 11/0'
    },
    {
        index: 6,
        brand: 'Miyuki',
        diameter: 1.3,
        width: 1,
        size: 15,
        shape: 'cylinder',
        name: 'Miyuki Delica 15/0',
        displayName: 'Miyuki Delica 15/0'
    },
    {
        index: 7,
        brand: 'TOHO',
        diameter: 4,
        width: 3.13,
        size: 6,
        shape: 'round',
        name: 'TOHO Round 6/0',
        displayName: 'TOHO Round 6/0'
    },
    {
        index: 8,
        brand: 'TOHO',
        diameter: 3,
        width: 2.35,
        size: 8,
        shape: 'round',
        name: 'TOHO Round 8/0',
        displayName: 'TOHO Round 8/0'
    },
    {
        index: 9,
        brand: 'TOHO',
        diameter: 2.14,
        width: 1.59,
        size: 11,
        shape: 'round',
        name: 'TOHO Round 11/0',
        displayName: 'TOHO Round 11/0'
    },
    {
        index: 10,
        brand: 'TOHO',
        diameter: 1.5,
        width: 1.175,
        size: 15,
        shape: 'round',
        name: 'TOHO Round 15/0',
        displayName: 'TOHO Round 15/0'
    },
    {
        index: 11,
        brand: 'TOHO',
        diameter: 1.8,
        width: 1.38,
        size: 11,
        shape: 'cylinder',
        name: 'TOHO Aiko 11/0',
        displayName: 'TOHO Aiko 11/0'
    },
    {
        index: 12,
        brand: 'TOHO',
        diameter: 1.8,
        width: 1.38,
        size: 11,
        shape: 'cylinder',
        name: 'TOHO Treasure 11/0',
        displayName: 'TOHO Treasure 11/0'
    },
    {
        index: 13,
        brand: 'Fuse Beads',
        diameter: 5,
        width: 5,
        size: 0,
        shape: 'plastic',
        name: 'Fuse Beads',
        displayName: 'Fuse Beads'
    }
];